import React from 'react';
import { connect } from 'react-redux';
import SaveSearchDialog from './SaveSearchDialog';
import SearchDeletionDialog from './SearchDeletionDialog';
import ShareSearchDialog from '../sharing/containers/ShareSearchDialog';

const SearchDialogs = ({
  allowDelete,
  allowSave,
  allowShare,
  theme,
}) => (
  <>
    {allowDelete && (<SearchDeletionDialog theme={theme} />)}
    {allowSave && (<SaveSearchDialog theme={theme} />)}
    {allowShare && (<ShareSearchDialog theme={theme} />)}
  </>
);

const mapStateToProps = ({
  auth: {
    role: {
      permissions: {
        search: {
          create, update, secure, share, destroy,
        },
      },
    },
  },
  search: {
    activeSearch, sharingSearch, deleteSearchOpen,
  },
}) => ({
  allowDelete: deleteSearchOpen && destroy,
  allowSave: activeSearch.open && (create || update),
  allowShare: sharingSearch.open && (secure || share),
});

export default connect(mapStateToProps)(SearchDialogs);
